'use client';

import { useEffect, useState } from 'react';

import { parseParagraphs } from '@/lib/utils';

import { useIsMobile } from './use-mobile';

export function useExpandableContent(content: string) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const { paragraphs, firstParagraph, hasMoreContent } =
    parseParagraphs(content);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  return {
    isExpanded,
    setIsExpanded,
    isLoaded,
    isMobile,
    paragraphs,
    firstParagraph,
    hasMoreContent,
    toggleExpand,
  };
}
